// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Button,
  ButtonComposed,
  Link,
  modal,
  itemList,
  Input,
} from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
import { processingUser } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CreateUser.m.scss";

const CreateUserMutation = itemList.MutationFactory(processingUser.add);

@themr("@lifepay/CreateUser", styles)
export default class CreateUser extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      submitButtonState: "normal",
      username: "",
      password: "",
      roles: ["callcenter", "processing"],
      firstName: "",
      lastName: "",
    };
  }

  handleInput = ({ id, value }) => {
    this.setState({ [id]: value });
  };

  render() {
    const { theme, onSuccess } = this.props;
    const {
      loading,
      error,
      submitButtonState,
      username,
      password,
      roles,
      firstName,
      lastName,
    } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <div className={classnames(theme.control)}>
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Добавить пользователя"}
                </Button>
              </div>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => (!loading ? close() : null)}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CreateUserMutation>
                  {(createUser, { data, dataState }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            createUser({
                              variables: {
                                username,
                                password,
                                roles,
                                firstName,
                                lastName,
                              },
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess &&
                                  onSuccess(response, {
                                    username,
                                    roles,
                                    firstName,
                                    lastName,
                                  });
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Создать"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <form
                          autoComplete="off"
                          className={classnames(theme.form)}
                        >
                          <div className={classnames(theme.inputs)}>
                            <div
                              className={classnames(theme.summary)}
                            >{`Создать пользователя`}</div>
                            <Input
                              id={"username"}
                              type={"username"}
                              value={username}
                              inputProps={{
                                name: "new",
                                autoComplete: "off",
                              }}
                              controlled
                              onChange={this.handleInput}
                            >
                              {"Имя пользователя"}
                            </Input>
                            {error ? (
                              <React.Fragment>
                                <div className={classnames(theme.summary)}>
                                  {error.message}
                                </div>
                                <div className={classnames(theme.summary)}>
                                  <Link
                                    type={"negative"}
                                    withRouter={false}
                                    onClick={() => {
                                      this.setState({
                                        error: null,
                                        submitButtonState: "normal",
                                      });
                                    }}
                                  >
                                    {"Очистить ошибку"}
                                  </Link>
                                </div>
                              </React.Fragment>
                            ) : null}
                          </div>
                          {submit}
                        </form>
                      </div>
                    );
                  }}
                </CreateUserMutation>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/CreateProcUser/CreateUser.js